import React, { useState } from "react";
import {
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  Table,
  Card
} from "reactstrap";
import InputData from "../../atoms/input-data";
import Icons from "../../atoms/icons";
import { cloneDeep } from "lodash";
import HelpTooltip from "../../atoms/help-tooltip";
import T from "../../atoms/translate";
import { t } from "../../../utils/utils";
export default function InsertSelector({
  fields,
  context,
  values,
  setValues,
  inputData,
  setInputData
}) {
  const [inputContext, setInputContext] = useState("");
  const [field, setField] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [localInputData, setLocalInputData] = useState({});
  //crud
  const addValues = value => {
    const temp = cloneDeep(values);
    temp.push(value);
    setValues(temp);
    setInputData(localInputData);
  };
  const updateValues = (index, value) => {
    const temp = cloneDeep(values);
    temp[index] = value;
    setValues(temp);
    setInputData(localInputData);
  };
  const deleteValues = index => {
    const temp = cloneDeep(values);
    temp.splice(index, 1);
    setValues(temp);
  };
  //
  const onUpdateValues = () => {
    updateValues(selectedIndex, { field: field, value: inputContext });
    clearInputs();
  };
  const onAddValue = () => {
    addValues({ field: field, value: inputContext });
    clearInputs();
  };
  const update = (index, o) => {
    setField(o.field);
    setInputContext(o.value);
    setSelectedIndex(index);
  };
  const clearInputs = () => {
    setSelectedIndex(null);
    setField("");
    setInputContext("");
  };
  const onChangeInput = input => {
    setLocalInputData(cloneDeep(inputData));
    Object.keys(input.inputData).forEach(o => {
      if (!Object.keys(inputData).includes(o)) {
        let tmp = inputData;
        tmp = { ...tmp, ...input.inputData };
        setLocalInputData(tmp);
      } else if (inputData[o].from !== input.inputData[o].from) {
        let tmp = inputData;
        tmp = { ...tmp, ...input.inputData };
        setLocalInputData(tmp);
      }
    });
    setInputContext(input.data);
  };
  const onSubmit = e => {
    e.preventDefault();
    if (selectedIndex != null) {
      onUpdateValues();
    } else {
      onAddValue();
    }
  };
  return (
    <>
      <Card body className="border-0 box-shadow mb-4">
        <Row>
          <Col xs="12">
            <h1 className="font-size-09 text-secondary fw-600 text-uppercase">
              <T i18nKey="selectorInsercionTitulo" />
            </h1>
          </Col>
          <Col xs="12">
            <Form onSubmit={onSubmit}>
              <Row form>
                <Col md={4}>
                  <FormGroup>
                    <Label>
                      <T i18nKey="selectorInsercionCampo" />{" "}
                      <HelpTooltip msg={t("selectorInsercionCampoTooltip")} />
                    </Label>
                    <Input
                      type="select"
                      value={field}
                      onChange={e => setField(e.target.value)}
                    >
                      <option value="" />
                      {fields.map((o, key) => (
                        <option key={key}>{o.name}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>
                      Valor{" "}
                      <HelpTooltip msg={t("selectorInsercionValoresTooltip")} />
                    </Label>
                    <InputData context={context} changeInput={onChangeInput}>
                      <Input
                        type="text"
                        value={inputContext}
                        onChange={e => setInputContext(e.target.value)}
                      />
                    </InputData>
                  </FormGroup>
                </Col>
                <Col md={4} className="offset-4">
                  {selectedIndex != null ? (
                    <Button color="success" type="submit">
                      <T i18nKey="actualizar" />
                    </Button>
                  ) : (
                    <Button color="primary" type="submit">
                      <T i18nKey="agregar" />
                    </Button>
                  )}
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>
      <Card body className="border-0 box-shadow mb-4">
        <Row>
          <Col xs="12">
            <h1 className="font-size-09 text-secondary fw-600 text-uppercase">
              <T i18nKey="selectorInsercionValores" />
            </h1>
          </Col>
          <Col xs="12">
            <Table bordered style={{ marginTop: "15px" }}>
              <thead>
                <tr>
                  <th>
                    <T i18nKey="campo" />
                  </th>
                  <th>
                    <T i18nKey="valor" />
                  </th>
                  <th>
                    <T i18nKey="editar" />
                  </th>
                  <th>
                    <T i18nKey="borrar" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {values.map((o, key) => (
                  <tr key={key}>
                    <td>{o.field}</td>
                    <td>{o.value}</td>
                    <td>
                      <Button
                        size="sm"
                        color="primary"
                        onClick={() => update(key, o)}
                      >
                        <Icons
                          Config={{ size: "1.2em", color: "white" }}
                          Icon="MdCreate"
                        />
                      </Button>
                    </td>
                    <td>
                      <Button
                        size="sm"
                        color="danger"
                        onClick={() => {
                          deleteValues(key);
                          clearInputs();
                        }}
                      >
                        <Icons
                          Config={{ size: "1.2em", color: "white" }}
                          Icon="MdDelete"
                        />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Card>
    </>
  );
}
